import { render, staticRenderFns } from "./StationPlaceRecentEvents.vue?vue&type=template&id=55d97fa4&scoped=true&"
import script from "./StationPlaceRecentEvents.vue?vue&type=script&lang=js&"
export * from "./StationPlaceRecentEvents.vue?vue&type=script&lang=js&"
import style0 from "./StationPlaceRecentEvents.vue?vue&type=style&index=0&id=55d97fa4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d97fa4",
  null
  
)

/* custom blocks */
import block0 from "./StationPlaceRecentEvents.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d97fa4')) {
      api.createRecord('55d97fa4', component.options)
    } else {
      api.reload('55d97fa4', component.options)
    }
    module.hot.accept("./StationPlaceRecentEvents.vue?vue&type=template&id=55d97fa4&scoped=true&", function () {
      api.rerender('55d97fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceRecentEvents/StationPlaceRecentEvents.vue"
export default component.exports